import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  inject,
  viewChild
} from '@angular/core';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { TranslateService } from '@ngx-translate/core';
import { Position } from 'geojson';
import mapboxgl, { LngLatLike } from 'mapbox-gl';
import { Subject, takeUntil, tap } from 'rxjs';

import { GetEnumValuesDto, SmsAggregator } from 'src/app/core/api/models';
import { CopyToClipboardDirective } from 'src/app/core/directives/copy-to-clipboard.directive';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { CustomPlaceModalComponent } from 'src/app/pages/smart-sms/custom-place/custom-place-modal/custom-place-modal.component';
import {
  LatLng,
  map_color_map,
} from '../smart-send-map-control/smart-send-map-control.component';

export interface SendSmartSmsConfirmationModel {
  id: any;
  total: number;
  sendCount: number;
  persianPrice: number;
  englishPrice: number;
  startFrom: number;
  polygon: Position[][];
  operator: SmsAggregator;
}

@Component({
    selector: 'app-smart-send-confirmation-map-component',
    templateUrl: './smart-send-confirmation-map.component.html',
    styleUrls: ['./smart-send-confirmation-map.component.scss'],
    standalone: false
})
export class SmartSendConfirmationMapComponent implements OnInit {
  appStateService = inject(AppStateService);
  componentVocab = 'components.smartSendConfirmation.';
  center: LngLatLike = [51.680374, 32.661343];
  map: mapboxgl.Map = null;
  drawer: MapboxDraw;
  cursorStyle: string = '';
  SelectedPolygonFillColor = '#166ae9';
  SelectedPolygonOpacity = 0.3;
  isExpandMap: boolean = true;
  hoverFilter = ['==', 'id', ''];
  selectedFilter: any[] = ['==', 'id', ''];
  selectedLayer: SendSmartSmsConfirmationModel | null = null;
  model: Array<SendSmartSmsConfirmationModel> | null = null;
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];

  @Input() DisplayPolygonFillColor = '#ff4492';
  @Input() DisplayPolygonFillOpacity = 0.3;
  @Input() isClickOnBtnNextStep: boolean = false;
  @Input() Zoom: number = 9;
  @Input() NextStepText: string =
    this.componentVocab + 'NextStep';
  @Input() SmsPartCount: number = 1;
  @Input() ShowPanel: boolean = true;
  @Input() showDetail: boolean = true;
  @Input() rounded: boolean = true;
  @Input('isDetailMode') isDetailPage: boolean = false;
  @Input() isShowToolbar: boolean = true;
  @Input() isRefreshPage: boolean = false;
  @Input() isShowSubmitBtn: boolean = true;
  @Input() selectedOperator: SmsAggregator;
  @Input() isUpdateMode: boolean = false;
  @Input() ShowAddToPublicPlace: boolean = false;
  @Input() isShowRecipients: boolean = true;
  @Input() height: number = 600;

  @Output() OnHelp: EventEmitter<object> = new EventEmitter<object>();
  @Output() OnLoad: EventEmitter<null> = new EventEmitter<null>();
  @Output('OnNextStepClick') OnNextStep: EventEmitter<
    Array<SendSmartSmsConfirmationModel>
  > = new EventEmitter<Array<SendSmartSmsConfirmationModel>>();
  @Output('model') output_model: EventEmitter<
    Array<SendSmartSmsConfirmationModel>
  > = new EventEmitter<Array<SendSmartSmsConfirmationModel>>();
  @Output('expandMap') output_expandMap: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  readonly extraDataContainer = viewChild<ElementRef>('extraDataContainer');

  DisplayPolygon: GeoJSON.FeatureCollection<GeoJSON.Polygon> = {
    features: [],
    type: 'FeatureCollection',
  };
  isWrongIndex: boolean = false;
  protected onDestroy$ = new Subject<void>();
  selectedPolygon: string;
  styleUrl: string;
  transformReq: any;
  private selectedFeatureId: string | null = null;
  get SmsParts(): number {
    if (this.SmsPartCount <= 0) return 1;
    else return this.SmsPartCount;
  }

  constructor(
    public dialogService: DialogService,
    private translate: TranslateService,
    private copy: CopyToClipboardDirective
  ) {}

  public setModel(_model: Array<SendSmartSmsConfirmationModel>) {
    this.model = _model;
    this.DisplayPolygon.features = [];
    this.model?.forEach((item) => {
      this.DisplayPolygon.features.push({
        geometry: {
          coordinates: item.polygon,
          type: 'Polygon',
        },
        type: 'Feature',
        id: item.id,
        properties: item,
      });
    });

    (this.map.getSource('polygon-source') as mapboxgl.GeoJSONSource).setData(
      this.DisplayPolygon
    );
    //create new empty bounding box
    const bounds = new mapboxgl.LngLatBounds();
    //extend the cordination of bounding box
    this.model?.forEach((item) => {
      var polygon = item.polygon as any;
      // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
      for (const coord of polygon[0]) {
        bounds.extend(coord);
      }
    }); //end of all polygn's loop
    //move map over bounding box
    if (this.isShowToolbar)
      this.map.fitBounds(bounds, {
        padding: 20,
      });
    else
      this.map.fitBounds(bounds, {
        duration: 0,
        padding: 20,
      });
  }
  ///<summery>
  ///This method get the map theme color url
  ///</summery>
  getMapStyleUrl() {
    let lightThemeUrl;
    let darkThemeUrl;
    lightThemeUrl = AppConfigService.config.useMapIr
      ? AppConfigService.config.mapIrStyleUrl
      : AppConfigService.config.gisStyleUrl;
    darkThemeUrl = AppConfigService.config.useMapIr
      ? AppConfigService.config.mapIrStyleDarkUrl
      : AppConfigService.config.gisStyleDarkUrl;
    if (this.appStateService.currentThemeMode() == map_color_map.light) {
      this.styleUrl = lightThemeUrl;
    } else if (this.appStateService.currentThemeMode() == map_color_map.dark)
      this.styleUrl = darkThemeUrl;
  }

  /**
   *
   * @param url this method inject the map.ir token in request's
   * @param resourceType
   * @returns
   */
  transformRequest(url: string, resourceType: any) {
    if (AppConfigService.config.useMapIr)
      // use for map.ir
      this.transformReq = {
        url: url,
        headers: {
          'x-api-key': AppConfigService.config.mapIrXApiKey,
        },
      };
    // use for gis
    else
      this.transformReq = {
        url: url,
        headers: {
          Accept:
            'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
          Origin: 'http://localhost:4200',
          'Access-Control-Request-Headers': 'access-control-allow-origin',
          'Access-Control-Request-Method': 'GET',
        },
      };
  }

  onHelpButtonClick($event) {
    this.OnHelp.emit($event);
  }

  ngOnInit(): void {
    this.getMapStyleUrl();
  }

  ngOnChanges(changes: SimpleChange) {
    if (changes['isRefreshPage']) {
      this.selectedLayer.sendCount = this.selectedLayer.total;
      this.selectedLayer.startFrom = 1;
      this.closeExtraData();
    }
    if (changes['selectedOperator']) {
      this.closeExtraData();
    }
    if (changes['Theme']) this.getMapStyleUrl();
  }

  onMapReady($event) {
    this.map = $event;
    const draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: false,
        trash: false,
      },
      styles: [
        // ACTIVE (being drawn)
        // line stroke
        {
          id: 'gl-draw-line',
          type: 'line',
          filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['!=', 'mode', 'static'],
          ],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#D20C0C',
            'line-dasharray': [0.2, 2],
            'line-width': 2,
          },
        },
        // polygon fill
        {
          id: 'gl-draw-polygon-fill',
          type: 'fill',
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
          paint: {
            'fill-color': '#D20C0C',
            'fill-outline-color': '#D20C0C',
            'fill-opacity': 0.1,
          },
        },
        // polygon mid points
        {
          id: 'gl-draw-polygon-midpoint',
          type: 'circle',
          filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
          paint: {
            'circle-radius': 5,
            'circle-color': '#fb3b3b',
          },
        },
        // polygon outline stroke
        // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
        {
          id: 'gl-draw-polygon-stroke-active',
          type: 'line',
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#D20C0C',
            'line-dasharray': [0.2, 2],
            'line-width': 1,
          },
        },
        // vertex point halos
        {
          id: 'gl-draw-polygon-and-line-vertex-halo-active',
          type: 'circle',
          filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
          ],
          paint: {
            'circle-radius': 7,
            'circle-color': '#FFF',
          },
        },
        // vertex points
        {
          id: 'gl-draw-polygon-and-line-vertex-active',
          type: 'circle',
          filter: [
            'all',
            ['==', 'meta', 'vertex'],
            ['==', '$type', 'Point'],
            ['!=', 'mode', 'static'],
          ],
          paint: {
            'circle-radius': 5,
            'circle-color': '#D20C0C',
          },
        },

        // INACTIVE (static, already drawn)
        // line stroke
        {
          id: 'gl-draw-line-static',
          type: 'line',
          filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['==', 'mode', 'static'],
          ],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#000',
            'line-width': 3,
          },
        },
        // polygon fill
        {
          id: 'gl-draw-polygon-fill-static',
          type: 'fill',
          filter: ['all', ['==', '$type', 'Polygon'], ['==', 'mode', 'static']],
          paint: {
            'fill-color': '#000',
            'fill-outline-color': '#000',
            'fill-opacity': 0.1,
          },
        },
        // polygon outline
        {
          id: 'gl-draw-polygon-stroke-static',
          type: 'line',
          filter: ['all', ['==', '$type', 'Polygon'], ['==', 'mode', 'static']],
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#000',
            'line-width': 2,
          },
        },
      ],
    });
    this.map.addControl(draw);
    this.drawer = draw;

    this.OnLoad.emit(null);
    this.map = $event;

    if (this.isDetailPage) {
      // Add the GeoJSON source to the map
      this.map.addSource('dataSource', {
        type: 'geojson',
        data: this.DisplayPolygon, // Replace with your actual GeoJSON data
      });

      // Add the layer to render the GeoJSON data
      this.map.addLayer({
        id: 'layer',
        type: 'fill', // Use 'fill' for polygons, 'line' for lines, 'circle' for points
        source: 'dataSource',
        paint: {
          'fill-color': '#D20C0C',
          'fill-outline-color': '#D20C0C',
          'fill-opacity': 0.1,
        },
      });
    }
  }
  // Example function to change color of the feature
  changeOpacityOfSelectedFeature(featureId: string) {
    this.map.setFeatureState(
      { source: 'dataSource', id: featureId }, // Target the feature by its id
      { selected: true } // Set a custom state for selected feature
    );

    this.applySelectedOpacity();
  }

  applySelectedOpacity() {
    this.map.setPaintProperty('layer', 'fill-opacity', [
      'case',
      ['==', ['feature-state', 'selected'], true], // If the feature is selected
      0.5, // Selected opacity
      0.1, // Default opacity
    ]);
  }

  resetOpacity(featureId: string) {
    this.map.setFeatureState(
      { source: 'dataSource', id: featureId }, // Target the feature by its id
      { selected: false } // Mark feature as not selected
    );

    this.applySelectedOpacity();
  }

  openExtraData() {
    if (!this.ShowPanel) return;
    this.extraDataContainer().nativeElement.classList.remove('close');
    document.querySelector('.map').classList.remove('expanded');
    this.map.resize();
  }

  closeExtraData() {
    this.extraDataContainer().nativeElement.classList.add('close');
    document.querySelector('.map').classList.add('expanded');
    this.map.resize();
  }

  isExtraDataOpen() {
    const extraDataContainer = this.extraDataContainer();
    if (extraDataContainer && extraDataContainer.nativeElement)
      return (
        extraDataContainer.nativeElement.classList.contains('close') ==
        false
      );
    else return true;
  }

  toggleExtraData() {
    if (this.extraDataContainer().nativeElement.classList.contains('close'))
      this.openExtraData();
    else this.closeExtraData();
  }

  onLayerClick(event: any) {
    this.selectedPolygon = event.features[0].properties.polygon;
    if (!this.selectedOperator && !this.isUpdateMode && !this.isDetailPage) {
      this.dialogService.openDialog({
        title: this.translate.instant('common.error'),
        message: this.translate.instant(
          'pages.confirmSmartSmsRequest.errors.mustSelectOperator'
        ),
        status: DialogStatus.error,
      });
      return;
    }

    let obj: any;
    if (this.selectedOperator)
      obj = event.features?.find(
        (item) => item.properties.operator == this.selectedOperator
      );

    this.isWrongIndex = false;
    let polygon = event.features[0].properties.polygon.substring(
      1,
      event.features[0].properties.polygon.length - 1
    );
    this.copy.copyValueToClipboard(polygon);
    this.selectNewLayer(obj?.properties as SendSmartSmsConfirmationModel);
    if (!this.isDetailPage && this.showDetail) this.gotoDown();
  }

  
  gotoDown() {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }

  convertJsonToString(polygon) {
    return JSON.stringify(polygon);
  }

  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  selectNewLayer(layer: SendSmartSmsConfirmationModel) {
    this.selectedFilter = ['==', 'id', layer?.id];
    //now most bind selected layer data to the view
    this.model?.forEach((item) => {
      if (item.id == layer?.id) {
        layer = item;
      }
    });
    this.selectedLayer = layer;
    this.checkTotalCountIsValid();

    //now most check if panel is closed then open it
    if (!this.isExtraDataOpen()) this.openExtraData();
  }

  activateHoverOn(evt: any) {
    this.hoverFilter = ['==', 'id', evt.features[0].properties.id];
    this.cursorStyle = 'pointer';
  }

  disableHover() {
    this.hoverFilter = ['==', 'id', ''];
    this.cursorStyle = '';
  }

  saveSelectedLayer() {
    return;
    if (this.selectedLayer != null) {
      this.model.forEach((element) => {
        if (element.id == this.selectedLayer.id) {
          element.sendCount = this.selectedLayer.sendCount;
          element.startFrom = this.selectedLayer.startFrom;
          ConsoleService.info('model', this.model);
        }
      });
    }
  }

  getPersianTotalPrice() {
    var total = 0;
    this.model?.forEach((item) => {
      total += item.persianPrice * item.sendCount;
    });
    return total;
  }

  getEnglishTotalPrice() {
    var total = 0;
    this.model?.forEach((item) => {
      total += item.englishPrice * item.sendCount;
    });
    return total;
  }

  /**
   * fire when user click on next step button
   */
  onBtnNextStep() {
    this.OnNextStep.emit(this.model);
  }

  emitModel() {
    //  this.output_model.emit(this.model)
  }
  /**
   * return the model
   * @returns
   */
  getModel(): Array<SendSmartSmsConfirmationModel> {
    return this.model;
  }

  setStartFrom(count) {
    this.selectedLayer.startFrom = this.getNumber(count);
    this.model.forEach((item) => {
      if (
        JSON.stringify(item.polygon) ==
          JSON.stringify(this.selectedLayer.polygon) &&
        item.operator == this.selectedOperator
      )
        item.startFrom = this.getNumber(count);
    });
    this.checkTotalCountIsValid();
  }

  setSendCount(count) {
    this.selectedLayer.sendCount = this.getNumber(count);
    this.model.forEach((item) => {
      if (
        JSON.stringify(item.polygon) ==
          JSON.stringify(this.selectedLayer.polygon) &&
        item.operator == this.selectedOperator
      )
        item.sendCount = this.getNumber(count);
    });
    this.checkTotalCountIsValid();
  }

  getNumber(num) {
    if (typeof num == 'number') {
      return num;
    }
    let number: Number = +num?.toString()?.getJustNumber();
    if (number) return +number;
    else return 0;
  }

  checkTotalCountIsValid() {
    if (
      this.selectedLayer.startFrom + this.selectedLayer.sendCount >
      this.selectedLayer.total + 1
    ) {
      this.isWrongIndex = true;
    } else {
      this.isWrongIndex = false;
    }
  }

  onAddToPublicPlaceButtonClick() {
    let selectedPolygon: any = this.selectedLayer?.polygon[0];

    if (selectedPolygon?.length > 0) {
      let polygon = selectedPolygon;

      const modalResult = this.dialogService.openModal({
        component: CustomPlaceModalComponent,
        data: {
          showAddToPublicPlace: this.ShowAddToPublicPlace,
          polygon: polygon,
        },
      });
      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe();
    } else {
      let errMsg = 'messages.selectPolygon';
      this.dialogService.openDialog({
        message: errMsg,
        status: DialogStatus.error,
      });
    }
  }

  emitExpandCollapseMap(type) {
    switch (type) {
      case 'collapse':
        this.isExpandMap = false;
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
        this.output_expandMap.emit(false);
        break;
      case 'expand':
        this.isExpandMap = true;
        this.output_expandMap.emit(true);
        break;
    }

    const timeout = setTimeout(() => {
      this.map.resize();
      clearTimeout(timeout);
    }, 100);
  }

  unSubs() {
    this.onDestroy$.next();
  }

  addErrorClassToInput(inputElement) {
    this.isWrongIndex = true;
    if (!inputElement) return;
    if (!(inputElement as HTMLInputElement).classList?.contains('input-error'))
      (inputElement as HTMLInputElement).classList?.add('input-error');
  }

  removeErrorClassFromInput(inputElement) {
    this.isWrongIndex = false;
    if (!inputElement) return;
    if ((inputElement as HTMLInputElement).classList?.contains('input-error'))
      (inputElement as HTMLInputElement).classList?.remove('input-error');
  }

  changeSelectedOperator(operator: SmsAggregator) {
    this.selectedOperator = operator;
  }

  changeStartFrom(item: any, totalCount: number, event) {
    let inputElement = <HTMLInputElement>event?.target;

    if (inputElement) {
      item.startFrom = this.getNumber(event?.target?.value);

      item?.startFrom == 0 || item?.startFrom > totalCount
        ? this.addErrorClassToInput(inputElement)
        : item?.startFrom + item.sendCount > totalCount + 1
        ? this.addErrorClassToBothInput(item.id)
        : this.removeErrorClassFromBothInput(item.id);
    }
  }

  changeCount(item: any, totalCount: number, event) {
    let inputElement = <HTMLInputElement>event?.target;

    if (inputElement) {
      item.sendCount = this.getNumber(event?.target?.value);

      item?.sendCount == 0 || item?.sendCount > totalCount
        ? this.addErrorClassToInput(inputElement)
        : item?.startFrom + item.sendCount > totalCount + 1
        ? this.addErrorClassToBothInput(item.id)
        : this.removeErrorClassFromBothInput(item.id);
    }
  }

  showPolygonOnMap(selectedRow: string) {
    if (!this.isDetailPage) return;

    const features = this.DisplayPolygon.features;

    for (const feature of features) {
      let coordinates = JSON.stringify([feature.geometry.coordinates[0]]);

      if (feature.geometry.type === 'Polygon' && coordinates == selectedRow) {
        // Check if a feature is clicked
        if (features && features.length > 0) {
          // Store the feature's ID (ensure your GeoJSON has an `id` property)
          const featureId = feature.id?.toString(); // Convert to string

          // If a feature was previously selected, reset its opacity
          if (this.selectedFeatureId && this.selectedFeatureId !== featureId) {
            this.resetOpacity(this.selectedFeatureId);
          }

          // change opacity the clicked feature
          this.changeOpacityOfSelectedFeature(featureId);

          this.flyToSelectedRowPolygon(feature.geometry.coordinates);
          // Update the currently selected feature
          this.selectedFeatureId = featureId;
        }

        break;
      }
    }
  }

  flyToSelectedRowPolygon(coordinates) {
    let latLng: LatLng = {
      lat: Number(coordinates[0][0][1]),
      lng: Number(coordinates[0][0][0]),
    };
    const target = {
      center: latLng,
      zoom: 13,
      bearing: 0,
      pitch: 0,
    };

    //fly to selected location
    this.map.flyTo({
      ...target,
      duration: 2500,
      essential: true,
    });
  }

  removeTrailingZeroes(coordinateArray: number[][]): number[][] {
    return coordinateArray.map((coord) => {
      return coord.map((num) => {
        // Convert to string, remove trailing zero and then back to number
        return parseFloat(num.toString());
      });
    });
  }

  //چک میکنه که فقط 1 مختصات هست یا بیشتر
  checkMultiplePolygons(polygons: any[]): boolean {
    return polygons.some(
      (polygon) =>
        Array.isArray(polygon) && polygon.some((item) => Array.isArray(item))
    );
  }

  async addErrorClassToBothInput(id) {
    let fromIndexInput = await this.getFromIndexInputFromDOM(id);
    let countInput = await this.getCountInputFromDOM(id);
    this.addErrorClassToInput(fromIndexInput);
    this.addErrorClassToInput(countInput);
  }

  async removeErrorClassFromBothInput(id) {
    let fromIndexInput = await this.getFromIndexInputFromDOM(id);
    let countInput = await this.getCountInputFromDOM(id);
    this.removeErrorClassFromInput(fromIndexInput);
    this.removeErrorClassFromInput(countInput);
  }

  async getFromIndexInputFromDOM(id: number): Promise<HTMLInputElement> {
    let countInputElement: HTMLInputElement;

    const formIndexInputs = document.querySelectorAll(
      '[data-from-index-input-id]'
    );
    formIndexInputs.forEach((inputElement) => {
      const DataAttr = inputElement.getAttribute('data-from-index-input-id');
      if (+DataAttr == id) {
        countInputElement = inputElement as HTMLInputElement;
      }
    });

    return countInputElement;
  }

  async getCountInputFromDOM(phonebookId: number): Promise<HTMLInputElement> {
    let fromIndexInputElement: HTMLInputElement;

    const toIndexInputs = document.querySelectorAll('[data-count-input-id]');

    toIndexInputs.forEach((inputElement) => {
      const DataAttr = inputElement.getAttribute('data-count-input-id');
      if (+DataAttr == phonebookId) {
        fromIndexInputElement = inputElement as HTMLInputElement;
      }
    });

    return fromIndexInputElement;
  }

  ngOnDestroy() {
    this.unSubs();
    this.onDestroy$.complete();
  }
}
